import {
  Block,
  ProgressBar,
  SvgIcon,
  Typography,
  palette,
  spacing,
  useBreakpoints,
} from "@stepapp/ui";
import React from "react";
import { useTranslation } from "react-i18next";
import { StyleSheet } from "react-native";

type Props = {
  stars: number;
  count: number;
  totalReviews: number;
};

const StarRatingItem = ({ stars, count, totalReviews }: Props) => {
  const { t } = useTranslation();
  const { sm } = useBreakpoints();

  return (
    <Block
      row
      key={stars}
      alignCenter
      justifyEnd
      style={{ minWidth: spacing.unit * (sm ? 53 : 38) }}
    >
      <Typography
        variant={sm ? "paragraph" : "smallLabel"}
        type="secondary"
        style={styles.starRatingText}
        ellipsizeMode="tail"
        numberOfLines={1}
      >
        {`${stars} ${stars === 1 ? t("screens.reviews.star") : stars < 5 ? t("screens.reviews.star_plural") : t("screens.reviews.star_many")}`}
      </Typography>
      <SvgIcon
        color={palette.primary.accent}
        name="star"
        size={sm ? 16 : 12}
        style={styles.starIcon}
      />
      <ProgressBar
        cap={totalReviews || 100}
        value={count}
        width={spacing.unit * (sm ? 28.5 : 15)}
        height={14}
      />
      <Typography
        variant={sm ? "paragraph" : "smallLabel"}
        type="secondary"
        style={styles.starAmountText}
      >
        {count}
      </Typography>
    </Block>
  );
};

export default React.memo(StarRatingItem);

const styles = StyleSheet.create({
  starIcon: {
    marginRight: spacing.unit * 0.5,
    marginLeft: spacing.unit,
  },
  starRatingText: {
    alignContent: "center",
    lineHeight: 15,
  },
  starAmountText: {
    alignContent: "center",
    lineHeight: 15,
    marginLeft: spacing.unit * 2,
    width: spacing.unit * 6.5,
  },
});
